import "./kanban.scss"
import { useState } from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { useLocalization } from "../../../../../providers/LocalizationProvider"
const Kanban = ({ formattedDragAndDropData, setZoneLabel, setZoneId }) => {
    const [data, setData] = useState(formattedDragAndDropData ?? [])
    const { voiceiiTags } = useLocalization()

    const onDragEnd = (result) => {
        if (!result.destination) return
        const { source, destination } = result

        if (source.droppableId !== destination.droppableId) {
            const sourceColIndex = data.findIndex((e) => e.id === source.droppableId)
            const destinationColIndex = data.findIndex((e) => e.id === destination.droppableId)

            const sourceCol = data[sourceColIndex]
            const destinationCol = data[destinationColIndex]

            const sourceTask = [...sourceCol.tasks]
            const destinationTask = [...destinationCol.tasks]

            const [removed] = sourceTask.splice(source.index, 1)
            destinationTask.splice(destination.index, 0, removed)

            data[sourceColIndex].tasks = sourceTask
            data[destinationColIndex].tasks = destinationTask

            setData(data)
        }
        if (data && data[1] && data[1]?.tasks) {
            const draggedDataLabel = data[1]?.tasks.map((item) => item.title)
            setZoneLabel(draggedDataLabel)
            const draggedDataIds = data[1]?.tasks.map((item) => +item.id)
            setZoneId(draggedDataIds)
        }
    }

    return (
        data &&
        data.length > 0 && (
            <DragDropContext onDragEnd={onDragEnd}>
                <div className="kanban">
                    {data.map((section, index) => (
                        <div key={index}>
                            <h3 style={{ margin: "0", fontWeight: "bold", marginBottom: "2px" }}>
                                {voiceiiTags(section.title)}
                            </h3>
                            <Droppable key={section.id} droppableId={section.id}>
                                {(provided) => (
                                    <div
                                        {...provided.droppableProps}
                                        className="kanban__section"
                                        ref={provided.innerRef}
                                    >
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(2, auto)", // Display two items in one row
                                                alignItems: "center",
                                                justifyContent: "start",
                                                height: "90px",
                                                gap: "10px",
                                            }}
                                        >
                                            {section?.tasks.map((task, index) => (
                                                <Draggable
                                                    key={task.id + index}
                                                    draggableId={task.id}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                                ...provided.draggableProps.style,
                                                                opacity: snapshot.isDragging
                                                                    ? "0.5"
                                                                    : "1",
                                                            }}
                                                        >
                                                            <div className="e-zone-map-card">
                                                                {task.title}
                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    </div>
                                )}
                            </Droppable>
                        </div>
                    ))}
                </div>
            </DragDropContext>
        )
    )
}

export default Kanban
